var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { useContext, useState } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { BotContext } from '../../Bot.js';
import styles from './ChatForm.module.css';
export const ChatForm = () => {
    const intl = useIntl();
    const { useTailwindPrefix, onSubmit, isFetching } = useContext(BotContext);
    const { handleSubmit, register, setValue, control } = useForm({});
    const message = useWatch({ control, name: 'message' });
    const [inputIsActive, setInputIsActive] = useState(false);
    const _a = register('message', { required: true }), { onBlur } = _a, rest = __rest(_a, ["onBlur"]);
    function onSubmitEvent(data) {
        setValue('message', '');
        onSubmit(data.message);
    }
    return (_jsx("div", Object.assign({ className: classNames({ 'p-4': !useTailwindPrefix, 'tw-p-4': useTailwindPrefix }) }, { children: _jsx("form", Object.assign({ onSubmit: handleSubmit(onSubmitEvent) }, { children: _jsxs("div", Object.assign({ className: classNames(Object.assign({}, (useTailwindPrefix
                    ? {
                        'tw-flex tw-gap-2 tw-items-end tw-bg-white tw-rounded-full tw-border tw-px-1 tw-py-1': true,
                        'tw-border-bot-accent': inputIsActive,
                        'tw-border-gray-200': !inputIsActive,
                    }
                    : {
                        'flex gap-2 items-end bg-white rounded-full  border px-1 py-1': true,
                        'border-bot-accent': inputIsActive,
                        'border-gray-200': !inputIsActive,
                    }))) }, { children: [_jsx("input", Object.assign({}, rest, { onFocus: (e) => {
                            setInputIsActive(true);
                        }, onBlur: (e) => {
                            setInputIsActive(false);
                            onBlur(e);
                        }, placeholder: intl.formatMessage({ id: 'maia_chatbot_input_placeholder' }), autoComplete: "off", className: classNames({
                            'flex-1 px-4 py-2 bg-transparent rounded-[inherit] outline-none border-0': !useTailwindPrefix,
                            'tw-flex-1 tw-px-4 tw-py-2 tw-bg-transparent tw-rounded-[inherit] tw-outline-none tw-border-0': useTailwindPrefix,
                        }) })), _jsx("button", Object.assign({ type: "submit", disabled: !message || message.trim() === '' || isFetching, className: classNames(styles.send_button, {
                            'w-10 h-10 text-bot-accent hover:text-bot-accent-a11y hover:bg-bot-accent disabled:text-gray-400 disabled:bg-transparent': !useTailwindPrefix,
                            'tw-w-10 tw-h-10 tw-text-bot-accent hover:tw-text-bot-accent-a11y hover:tw-bg-bot-accent disabled:tw-text-gray-400 disabled:tw-bg-transparent': useTailwindPrefix,
                        }) }, { children: _jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: classNames({
                                'mt-1 mr-1': !useTailwindPrefix,
                                'tw-mt-1 tw-mr-1': useTailwindPrefix,
                            }) }, { children: [_jsx("path", { d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z" }), _jsx("path", { d: "m21.854 2.147-10.94 10.939" })] })) }))] })) })) })));
};
